import { useEffect, useState } from 'react';
import userManager from 'src/userManager';
import ConsoleHelper from '../functions/consoleHelper';

// Hur länge vi väntar på identity innan vi ger upp och visar inloggningssidan. Den dolda
// iframen svarar normalt direkt, så en kortare gräns än bibliotekets tio sekunder räcker
// och sparar en lång tom skärm när identity inte går att nå.
const silentRequestTimeout = 5000;

// Ett försök per fliks livstid. Flaggan ligger på modulnivå just därför: skyddsrutinerna
// monteras om vid varje navigering, och utan den skulle en utloggad besökare göra ett nytt
// försök för varje sida hen klickar på.
let hasTriedSilentSignin = false;

// oidc-client lagrar den inloggade användaren i sessionStorage, som är privat per flik. En ny
// flik börjar därför tom även om man redan är inloggad. Identity-serverns egen sessionskaka
// delas däremot av alla flikar, så vi kan hämta inloggningen i en dold iframe i stället för
// att visa inloggningssidan och låta användaren klicka på en knapp som inte frågar något.
export const useSilentSignin = (enabled: boolean): boolean => {
  const [isSigningIn, setIsSigningIn] = useState(enabled && !hasTriedSilentSignin);

  useEffect(() => {
    if (!enabled || hasTriedSilentSignin) {
      setIsSigningIn(false);
      return;
    }

    hasTriedSilentSignin = true;
    setIsSigningIn(true);

    // Lyckas den dispatchar OidcProvider userFound och skyddsrutinen ritar om sig med en
    // inloggad användare. Misslyckas den, till exempel med login_required eller för att
    // max_age har passerat, faller vi tillbaka på inloggningssidan.
    userManager
      .signinSilent({ silentRequestTimeout })
      .catch((error) => {
        ConsoleHelper.log('SILENT SIGNIN FAILED', error);
      })
      .finally(() => {
        setIsSigningIn(false);
      });
  }, [enabled]);

  return isSigningIn;
};

export default useSilentSignin;
